import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card, Input } from "@rumbledirect/ui";
import { Flex, Form } from "antd";
import { useEffect } from "react";
import { ReplacementTransportOption } from "@rumble-it/common-lib/types/models/ReplacementTransportOption.interface";
import { ImageUpload } from "../../../../../components/form/ImageUpload";

export type ReplacementTransportOptionInputDto = Omit<
  ReplacementTransportOption,
  "headerImage"
> & {
  headerImage?: string | null;
};

interface ReplacementTransportOptionFormCardProps {
  mutation: UseMutationResult<
    ReplacementTransportOption | null,
    Error,
    ReplacementTransportOptionInputDto,
    unknown
  >;
  initialValues?: ReplacementTransportOption;
  loading?: boolean;
  title?: string;
  buttonText?: string;
}

export const ReplacementTransportOptionFormCard = ({
  mutation,
  initialValues,
  title = "Vervangend vervoer optie aanmaken",
  buttonText = "Aanmaken",
  loading = false,
}: ReplacementTransportOptionFormCardProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form, initialValues]);

  const handleFinish = (values: ReplacementTransportOption) => {
    const payload = {
      ...values,
      headerImage: values.headerImage?.["@id"] || null,
    };
    mutation.mutate(payload);
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical">
      <Flex vertical gap={16}>
        <Card loading={loading} title={title}>
          <Form.Item
            rules={[{ required: true, message: "Dit veld is verplicht" }]}
            label="Naam"
            name="title"
          >
            <Input />
          </Form.Item>
          <Form.Item
            rules={[
              {
                max: 160,
                message:
                  "De inhoud van de beschrijving mag maximaal 160 karakters bevatten.",
              },
            ]}
            label="Beschrijving"
            name="description"
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item label="Afbeelding" name="headerImage">
            <ImageUpload />
          </Form.Item>
          <Form.Item label={null}>
            <Button
              loading={mutation.isPending}
              type="primary"
              htmlType="submit"
            >
              {buttonText}
            </Button>
          </Form.Item>
        </Card>
      </Flex>
    </Form>
  );
};
